import { render } from "./CellLoaderRaw.vue?vue&type=template&id=672fa81b&scoped=true&ts=true"
import script from "./CellLoaderRaw.vue?vue&type=script&lang=ts"
export * from "./CellLoaderRaw.vue?vue&type=script&lang=ts"

import "./CellLoaderRaw.vue?vue&type=style&index=0&id=672fa81b&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672fa81b"]])

export default __exports__